<div class="modal-body">
    <button class="btn modal-close" (click)="activeModal.dismiss()">
        <i class="icon icon-x"></i>
    </button>

    <resource-card [resource]="resource" cardType="detailed"></resource-card>
</div>
